import type { HelpFile } from '../../types/help'
import { ReportCategoriesPageTestIds } from '../../../testids/ReportCategoriesPageTestIds'

export const reportCategoriesPageHelp: HelpFile = {
  docPage: '/docs/reporting/categories',
  texts: {
    [ReportCategoriesPageTestIds.categoriesPage]:
      'Folder-style groupings used to organise report definitions.',
    [ReportCategoriesPageTestIds.btnCreateCategory]:
      'Create a new report category.',
    [ReportCategoriesPageTestIds.btnPickParentCategory]:
      'Pick a parent category to nest this category under.',
    [ReportCategoriesPageTestIds.selectCategoryType]:
      'Filter by category type.',
    [ReportCategoriesPageTestIds.colName]: null,
    [ReportCategoriesPageTestIds.colCategory]:
      'Parent category this entry belongs to.',
    [ReportCategoriesPageTestIds.colType]: null,
    [ReportCategoriesPageTestIds.colLastModified]: null,
    [ReportCategoriesPageTestIds.colActions]: null,
    [ReportCategoriesPageTestIds.colNameSearch]:
      'Filter by category name.',
    [ReportCategoriesPageTestIds.colCategorySearch]:
      'Filter by parent category.',
    [ReportCategoriesPageTestIds.colTypeSearch]:
      'Filter by category type.',
    [ReportCategoriesPageTestIds.colLastModifiedSearch]:
      'Filter by last-modified date.',
  },
}
